/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : AddRole.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import CustomFormTextFieldV2 from "../../../components/customComponentsV2/common/textField/CustomFormTextFieldV2";

import CustomFormTextFieldV3 from "../../../components/customComponentsV2/common/textField/CustomFormTextFieldV3";
import CustomSelectV3 from "../../../components/customComponentsV2/common/select/CustomSelectV3";
import { useDispatch, useSelector } from "react-redux";
import {
  adminSettingsAPI,
  HandleApiActions,
  userManagementApis,
} from "../../../redux/actions";
import roletypeActions from "../../../redux/actions/roletypeActions";
import CustomSelectV2 from "../../../components/customComponentsV2/common/select/CustomSelectV2";
function AddRole({
  open,
  title,
  onClose,
  handleGetRolesAndAccessList,
  rolesAndAccessData,
}) {
  console.log("rolesAndAccessDatarolesAndAccessData", rolesAndAccessData);
  const dispatch = useDispatch();
  const roleTypesAll = useSelector(
    (state) => state.roleTypeReducers.roleTypesAll,
  );
  const [roleName, setRoleName] = useState("");
  const [roleNameError, setRoleNameError] = useState("");
  const [department, setDepartment] = useState("");
  const [departmentError, setDepartmentError] = useState("");
  const [subDepartment, setSubDepartment] = useState("");
  const [subDepartmentError, setSubDepartmentError] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [roleType, setRoleType] = useState("");
  const [organisation, setOrganisation] = useState("");
  const [organisationError, setOrganisationError] = useState("");
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [filteredRoleTypes, setFilteredRoleTypes] = useState(null);
  const isFormValidAdd = useMemo(() => {
    return (
      roleName?.trim() &&
      roleType &&
      department?.trim() &&
      description?.trim()
    
      // !roleNameError &&
      // !departmentError &&
      // !subDepartmentError &&
      // !descriptionError 
    );
  }, [roleName, roleType, department,description]);
  const isFormValidEdit = useMemo(() => {
    return description?.trim() !== rolesAndAccessData?.description?.trim();
  }, [description]);

  useEffect(() => {
    dispatch(
      HandleApiActions({
        ...roletypeActions.get_all_roletype,
        params: {
          isActive: true,
          isSystem: false,
          page_size: 100,
        },
      }),
    );
  }, []);

  console.log("roleTypesAll?.data?.roleTypes", roleTypesAll?.data?.roleTypes);
  const roleTypeList = useMemo(() => {
    return roleTypesAll?.data?.roleTypes?.map((data, idx) => ({
      label: data?.display_name,
      value: data?.role_type_id,
      capability_code: data?.capability_code,
    }));
  }, [roleTypesAll, roleType]);
  useEffect(() => {
    if (title?.toUpperCase() === "UPDATE ROLE") {
      console.log(
        "rolesAndAccessDatarolesAndAccessDatarolesAndAccessData",
        rolesAndAccessData,
      );
      setOrganisation()
      setRoleName(rolesAndAccessData?.name || "");
      setDepartment(rolesAndAccessData?.department || "");
      setSubDepartment(rolesAndAccessData?.sub_department || "");
      setDescription(rolesAndAccessData?.description || "");
      setRoleType(
        roleTypeList?.find(
          (x) => x.label === rolesAndAccessData?.role_type_name,
        )?.value ?? "",
      );
    }
  }, [title, rolesAndAccessData, roleTypeList]);

  useEffect(() => {
    if (!roleTypesAll?.data?.roleTypes) return;

    const filteredRoles = roleTypesAll?.data?.roleTypes?.filter(
      (data) => data?.role_type_id === roleType,
    );

    setFilteredRoleTypes((prev) => {
      if (JSON.stringify(prev) === JSON.stringify(filteredRoles)) {
        return prev; // no update → no re-render
      }
      return filteredRoles;
    });
  }, [roleType, roleTypesAll]);

  console.log("roleTypeListroleTypeList", roleTypeList);
  console.log("filteredRoleTypesfilteredRoleTypes", filteredRoleTypes);
  const handleRoleAndAccessFinish = () => {
    if (title?.toUpperCase() === "ADD ROLE") {
      let reqObj = {
        name: roleName,
        ...(description && { description: description }),

        roleTypeId: roleType,
        is_active: true,
        department: department,

        ...(subDepartment && { subDepartment: subDepartment }),
        organization: organisation,
      };

      dispatch(
        HandleApiActions({
          ...userManagementApis.add_role_ddh_ucm,
          params: reqObj,
          show_toast: true,
        }),
      ).then(() => {
        handleGetRolesAndAccessList();
      });
      onClose();
    } else if (title?.toUpperCase() === "UPDATE ROLE") {
      let reqObj = {
        ...(description && { description: description }),
        is_active: true,
      };
      dispatch(
        HandleApiActions({
          ...userManagementApis.update_role_ddh_ucm,
          api_name: `/UCM/roles/${rolesAndAccessData?.role_id}`,
          params: reqObj,
          show_toast: true,
        }),
      ).then(() => {
        handleGetRolesAndAccessList();
      });
      onClose();
    }
    let currentTime = new Date().toISOString();
  };
  useEffect(() => {
    if (
      filteredRoleTypes?.length > 0 &&
      filteredRoleTypes[0]?.capability_code === "EXTERNAL_SUPPLIER_USER"
    ) {
      // Fetch data for Supplier role type
      dispatch(
        HandleApiActions({
          ...adminSettingsAPI.get_admin_settings,
          show_toast: false,
        }),
      )
        .then((response) => {
          console.log("Full API Response:", response);
          const ecuSuppliers = response?.data?.ecu_suppliers;

          if (ecuSuppliers && Array.isArray(ecuSuppliers)) {
            console.log("ECU Suppliers Response:", ecuSuppliers);

            // Map ECU suppliers to dropdown options
            const supplierOptions = ecuSuppliers.map((supplier) => ({
              value: supplier.name,
              label: `${supplier.name}`,
            }));
            setOrganizationOptions(supplierOptions);
          } else {
            console.warn("No ECU suppliers data found in the response.");
          }
        })
        .catch((error) => {
          console.error("Error fetching organizations:", error);
        });
    } else {
      // Clear options and description if role type is not Supplier
      setOrganizationOptions([]);
      setDescription("");
    }
  }, [roleType, filteredRoleTypes]);
  return (
    <div>
      <Dialog
        open={open}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 1.5 },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            position: "relative",
            textAlign: "center",
            borderBottom: "1px solid #e0e0e0",
            pb: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>

          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Main Content */}
        <DialogContent
          sx={{
            mt: 2,
            maxHeight: "60vh",
            overflowY: "auto",
            pr: 1,
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#b0b0b0",
              borderRadius: "8px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#888",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
              borderRadius: "8px",
            },
          }}
        >
          <Box display="flex" flexDirection="column" gap={2}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: 1,
                width: "100%",
              }}
            >
              <CustomFormTextFieldV2
                disabled={title?.toUpperCase() === "UPDATE ROLE"}
                size="small"
                label="Role Name"
                placeholder="Role Name"
                required={true}
                type="text"
                fldType="text"
                value={roleName}
                setValue={setRoleName}
                valueError={roleNameError}
                setValueError={setRoleNameError}
                
                maxLength={60}
              />
              {/* <CustomRadioButtonV3
                size="small"
                label="Role Type"
                required={true}
                data={[
                  { value: 0, label: "Compliance Requestor" },
                  { value: 1, label: "Compliance Reviewer" },
                  { value: 2, label: "Supplier" },
                ]}
                value={roleType}
                onChange={(e) => setRoleType(e.target.value)}
                // txtFldStyle={styles.customTextFieldN}
                direction={"column"}
                gap={1.5}
              /> */}
              {/* <CustomSelectV3
                size="small"
                disabled={title?.toUpperCase() === "UPDATE ROLE"}
                // infoname="project_status"
                placeholder="Select Role Type"
                label="Role Type"
                required
                handleOnChange={(e) => setRoleType(e.target.value)}
                selectedValue={roleType}
                optionsList={roleTypeList}
              /> */}
              {/* <CustomSelectV3
                disabled={title?.toUpperCase() === "UPDATE ROLE"}
                label={"Role Type"}
                enableSearch
                required={true}
                handleOnChange={(e) =>
                  setRoleType(e.target.value === "" ? null : e.target.value)
                }
                selectedValue={roleType}
                optionsList={roleTypeList || []}
                sltFldStyle={{
                  minHeight: "45px",
                  fontSize: "0.95rem",
                  borderRadius: 0,
                }}
              /> */}
              {console.log("roleTyperoleType", roleType)}
              <CustomSelectV2
                disabled={title?.toUpperCase() === "UPDATE ROLE"}
                showLabel
                heightExpand={true}
                // size="medium"
                enableSearch={true}
                required={true}
                label="Role Type"
                
                optionsList={roleTypeList || []}
                selectedValue={roleType}
                handleOnChange={(e) => setRoleType(e.target.value)}
              />
              <CustomFormTextFieldV2
                size="small"
                disabled={title?.toUpperCase() === "UPDATE ROLE"}
                required={true}
                label="Function"
                placeholder="Function"
                type="text"
                fldType="text"
                value={department}
                setValue={setDepartment}
                
              />
              <CustomFormTextFieldV3
                disabled={title?.toUpperCase() === "UPDATE ROLE"}
                size="small"
                label="Description"
                placeholder="Description"
                type="text"
                fldType="text"
                value={organisation}
                setValue={setOrganisation}
                
                maxLength={60}
              />
              <CustomFormTextFieldV3
                disabled={title?.toUpperCase() === "UPDATE ROLE"}
                size="small"
                label="Sub-Function "
                placeholder="Sub-Function"
                type="text"
                fldType="textO"
                value={subDepartment}
                setValue={setSubDepartment}
                
              />
              {/* <CustomFormTextFieldV3
                disabled={title?.toUpperCase() === "UPDATE ROLE"}
                size="small"
                required={true}
                label="Organization"
                placeholder="Organization"
                type="text"
                fldType="text"
                value={organisation}
                setValue={setOrganisation}
                valueError={organisationError}
                setValueError={setOrganisationError}
                isMultiline
                minRows={1}
                maxRows={4}
                // txtFldStyle={styles.customTextFieldN}
              /> */}
              {filteredRoleTypes?.length > 0 &&
              filteredRoleTypes[0]?.capability_code ===
                "EXTERNAL_SUPPLIER_USER" ? (
                <CustomSelectV3
                 
                  size="small"
                  required={true}
                  label="Organization"
                  placeholder={"Select Organisation"}
                  optionsList={organizationOptions}
                  selectedValue={description}
                  handleOnChange={(e) => setDescription(e.target.value)}
                />
              ) : (
                <CustomFormTextFieldV3
                  
                  size="small"
                  required={true}
                  label="Organization"
                  placeholder="Organization"
                  type="text"
                  fldType="text"
                  value={description}
                  setValue={setDescription}
                  valueError={organisationError}
                  setValueError={setOrganisationError}
                  isMultiline
                  minRows={1}
                  maxRows={4}
                  
                />
              )}
            </Box>
          </Box>
        </DialogContent>

        {/* Footer */}
        <DialogActions
          sx={{
            borderTop: "1px solid #e0e0e0",
            pt: 1,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <>
            <CustomButtonV2
              type="cancel"
              btnName="Cancel"
              handleOnClick={onClose}
            />
            {title?.substring(0, 6).toLowerCase() === "update" ? (
              <CustomButtonV2
                disabled={!isFormValidEdit}
                type="submit"
                btnName={
                  title?.substring(0, 6).toLowerCase() === "update"
                    ? "Update Role"
                    : "Create Role"
                }
                handleOnClick={handleRoleAndAccessFinish}
              />
            ) : (
              <CustomButtonV2
                disabled={!isFormValidAdd}
                type="submit"
                btnName={
                  title?.substring(0, 6).toLowerCase() === "update"
                    ? "Update Role"
                    : "Create Role"
                }
                handleOnClick={handleRoleAndAccessFinish}
              />
            )}
          </>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AddRole;
